export default {
  video: {},
  products: [],
  shared_platform_details: {},
  influencer_detail: {},
};
